export default "__VITE_ASSET__Ceb7BlYj__"